import gsap from 'gsap'
// import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { v, au } from '../koko-framework/shorthand'
import app from '../koko-framework/app'
import * as PIXI from 'pixi.js'
// import { GAME_ORDER } from '../model/GameModel'
// import gameState from '../model/GameModel'
import { moreInfoController } from '../Bootstrap'
import { setupClicker } from '../controller/ButtonController'

export class MainMenuView extends koko.view {
    clickAllowed = false;
    popOpen = false;

    /* constructor (){
        super();
    } */

    buildView (){
        var vp = app.viewPort;

        this.children = koko.display.buildLayout([
            { type: 'sprite', id: 'BG_pattern', name: 'bg', x: -280, y: 0, width: 1326, height: 1355},

            { type: 'sprite', id: 'MathsWeek_logo', name: 'mwlogo', x: 210, y: 225, width: 182, height: 76, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'openUNi_logo', name: 'oulogo', x: 589, y: 225, width: 112, height: 76, anchorX: 0.5, anchorY: 0.5},

            { type: 'sprite', id: 'Codebreak_logo', name: 'cblogo', x: vp.centerX, y: 482, width: 434, height: 330, anchorX: 0.5, anchorY: 0.5},

            { type: 'bmptext', text: 'Think you can crack the codes?\nPlay the game to find out!', font: 'typrighter_small', size: 30, tint: 0, name: 'blurbText1', align:'center', x: vp.centerX, y: 672, anchorX: 0.5, anchorY: 0},

            { type: 'sprite', id: 'playgame_btn', name: 'play_btn', x: vp.centerX, y: 840, width: 434, height: 105, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'findout_btn', name: 'findout_btn', x: vp.centerX, y: 960, width: 434, height: 105, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'share_btn', name: 'share_btn', x: 314, y: 1080, width: 298, height: 105, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'sfx_off', name: 'sound_btn', x: 535, y: 1080, width: 126, height: 105, anchorX: 0.5, anchorY: 0.5},

            /*
            { type: 'shape', name: 'bg', x: -vp.x, y: -vp.y, width: vp.width + vp.x * 2, height: vp.height + vp.y * 2, fill: 0, alpha: 0.6},
            { type: 'sprite', id: 'carrier_big', name: 'bg2', x: vp.centerX, y: 678, width: 642, height: 1066, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'gameover_title', name: 'title', x: vp.centerX, y: 246, width: 268, height: 62, anchorX: 0.5, anchorY: 0.5},
            { type: 'bmptext', text: 'You successfully decoded the secret message\nusing frequency analysis.', font: 'typrighter_small', size: 30, tint: 0, name: 'successText', align:'center', x: vp.centerX, y: 296, anchorX: 0.5, anchorY: 0},
            { type: 'sprite', id: 'rank_1star', name: 'rank', x: vp.centerX, y: 543, width: 358, height: 356, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'feedback_banner', name: 'feedback', x: vp.centerX, y: 777, width: 466, height: 114, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'previous_header', name: 'prevhead', x: vp.centerX, y: 880, width: 224, height: 38, anchorX: 0.5, anchorY: 0.5},

            { type: 'container', name: 'prev1', x: 385, y: 936},
                { type: 'bmptext', parent: 'prev1', text: 'CAESAR CIPHER', font: 'typrighter_small', size: 30, tint: 0, name: 'prev1text', align:'left', x: -153, y: -13, anchorX: 0, anchorY: 0},
                { type: 'sprite', parent: 'prev1', id: 'rank_empty', name: 'prev1r1', x: 66, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev1', id: 'rank_empty', name: 'prev1r2', x: 99, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev1', id: 'rank_empty', name: 'prev1r3', x: 131, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
            
            { type: 'container', name: 'prev2', x: 385, y: 980},
                { type: 'bmptext', parent: 'prev2', text: 'PIG PEN', font: 'typrighter_small', size: 30, tint: 0, name: 'prev2text', align:'left', x: -153, y: -13, anchorX: 0, anchorY: 0},
                { type: 'sprite', parent: 'prev2', id: 'rank_empty', name: 'prev2r1', x: 66, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev2', id: 'rank_empty', name: 'prev2r2', x: 99, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev2', id: 'rank_empty', name: 'prev2r3', x: 131, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},

            { type: 'sprite', id: 'continue_btn', name: 'continue_btn', x: vp.centerX, y: 1090, width: 434, height: 105, anchorX: 0.5, anchorY: 0.5},
            */
        ], this.container);

        /*
        let scoresFound = false;
        for (let i = 0; i < GAME_ORDER.length - 1; i++) {
            if (gameState.gameScores[i] > 0 && gameState.currentGame > i) {
                scoresFound = true;
                this.children['prev' + (i + 1)].visible = true;
                for (let j = 1; j <= gameState.gameScores[i]; j++) {
                    this.children['prev' + (i + 1) + 'r' + j].texture = PIXI.Texture.from('rank_full.png');
                }
            } else {
                this.children['prev' + (i + 1)].visible = false;
            }
        }
        if (!scoresFound) {
            this.children.prevhead.visible = false;
        }

        this.children.successText.text = GAME_ORDER[gameState.currentGame].successMessage;

        if (gameState.gameScores[gameState.currentGame] > 1) {
            this.children.rank.texture = PIXI.Texture.from('rank_' + gameState.gameScores[gameState.currentGame] + 'stars.png');
        }
        if (gameState.gameScores[gameState.currentGame] < 3) {
            this.children.feedback.texture = PIXI.Texture.from('feedback_banner_' + gameState.gameScores[gameState.currentGame] + 'stars.png');
        }
        */

        this.setMuteButtonTexture();
        this.resize();
    }

    resize () {
        /*
        var vp = app.viewPort;
        let bg = this.children.bg;
        bg.x = -vp.x;
        bg.y = -vp.y;
        bg.width = vp.width + Math.abs(vp.x) * 2;
        bg.height = vp.height + Math.abs(vp.y) * 2;
        */
    }

    transitionIn = () => {
        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, {alpha:1, duration: 0.35});

        // setTimeout(this.transitionOut, 3000);

        /*
        this.children.continue_btn.interactive = true;
        this.children.continue_btn.on('mousedown', this.nextGame);
        this.children.continue_btn.on('pointerdown', this.nextGame);
        this.children.continue_btn.on('touchstart', this.nextGame);
        */

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.sound_btn.interactive = true;
        this.children.sound_btn.on(event, this.toggleMute);
        this.children.play_btn.interactive = true;
        this.children.play_btn.on(event, this.transitionOut);

        this.children.share_btn.interactive = true;
        this.children.share_btn.on(event, this.showSharePop);

        this.children.findout_btn.interactive = true;
        this.children.findout_btn.on(event, this.showMoreInfo);
        */
        setupClicker(this.children.sound_btn, this.toggleMute);
        setupClicker(this.children.play_btn, this.transitionOut);
        setupClicker(this.children.share_btn, this.showSharePop);
        setupClicker(this.children.findout_btn, this.showMoreInfo);

        // console.log(koko.client);

        this.clickAllowed = true;
        this.popOpen = false;
    }

    transitionOut = () => {
        if (!this.popOpen) {
            au.play('button', 1, false);
            gsap.to(this.container, {alpha:0, onComplete:this.transitionOutDone, duration: 0.35});
        }
    }

    transitionOutDone = () => {
        if (!this.popOpen) {
            // gsap.killAll();
            // this.destroyGameObjects();  
            // game.destroy();
            // game = null;
            this.destroyView();
            this.hide();

            /*
            PIXI.Ticker.shared.stop();
            app.renderer.renderer.plugins.interaction.destroy();

            app.paused = true;
            app.renderer.destroy();
            PIXI.utils.destroyTextureCache();
            */

            v.get('levelselect').transitionIn();
        }
    }

    /*
    nextGame = (e) => {
        if (this.clickAllowed) {
            this.transitionOut();
            gameState.nextGame();
            this.clickAllowed = false;
        }
    }
    */

    setMuteButtonTexture = () => {
        this.children.sound_btn.texture = koko.audio.mute ? PIXI.Texture.from('sfx_off.png') : PIXI.Texture.from('sfx_on.png');
    }

    toggleMute = () => {
        if (!this.popOpen) {
            koko.audio.toggleMute();
            this.setMuteButtonTexture();
            au.play('button', 1, false);
        }
    }

    showSharePop = () => {
        if (!this.popOpen) {
            au.play('button', 1, false);
            this.popOpen = true;
            // v.get('sharepop').transitionIn(this);
            moreInfoController.hiddenCallback = this.popClosed;
            moreInfoController.showSharePop();
        }
    }

    popClosed = () => {
        if (this.popOpen) {
            this.popOpen = false;
        }
    }

    showMoreInfo = () => {
        if (!this.popOpen) {
            au.play('button', 1, false);
            this.popOpen = true;
            moreInfoController.hiddenCallback = this.popClosed;
            moreInfoController.showMoreInfo();
        }
    }
}